'use strict';

angular.module('casist.sklad', []);